<section class="video-uploader">
  <header class="video-header">
    <span class="video-heading-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <rect x="3" y="5" width="14" height="14" rx="3"></rect>
        <path d="m17 10 4-2v8l-4-2z"></path>
      </svg>
    </span>
    <span class="video-heading-copy">
      <strong>{{"video.attach" | translate}}</strong>
      <small>הוסיפו סרטון קצר שמציג את המודעה בצורה הטובה ביותר</small>
    </span>

    @if (uploading) {
      <button class="video-action danger-action" type="button" (click)="cancelUpload()">
        <mat-icon>close</mat-icon>
        {{"upload.cancelupload.cancel" | translate}}
      </button>
    }

    @if (!uploading && uploadedMeta) {
      <button class="video-action danger-action" type="button" (click)="removeVideo()">
        <mat-icon>delete_outline</mat-icon>
        {{"common.remove" | translate}}
      </button>
    }
  </header>

  @if (uploading) {
    <div class="upload-progress" role="status" aria-live="polite">
      <div class="progress-copy">
        <span>מעלים את הסרטון...</span>
        <strong>{{ progress }}%</strong>
      </div>
      <div class="progress-track" aria-hidden="true">
        <span [style.width.%]="progress"></span>
      </div>
    </div>
  }

  @if (!uploading && uploadedMeta) {
    <div class="preview">
      <div class="videoFrame">
        @if (previewUrl) {
          <video [src]="uploadedMeta.preview_url" controls></video>
        }
        <span class="upload-success"><mat-icon>check</mat-icon> הסרטון מוכן</span>
      </div>
    </div>
  }

  @if (!uploadedMeta) {
    <label class="video-pick" [class.disabled]="uploading">
      <input
        type="file"
        accept="video/*"
        [disabled]="uploading"
        (change)="pickVideo($event.target)" />
      <span class="pick-icon" aria-hidden="true"><mat-icon>video_call</mat-icon></span>
      <strong>{{ uploading ? (('sale4all.loading' | translate) + progress + '%') : ('sale4all.select_video' | translate) }}</strong>
      <span class="pick-hint">לחצו לבחירת סרטון מהמכשיר</span>
      <small>{{"uploadFlow.createSessionToS3" | translate}}</small>
    </label>
  }
</section>
